<template>
  <v-container fluid tag="section">
    <base-material-table-mobile
      outlined
      :item="item"
      ref="table"
      @on-add='add'
      single-expand
      row-click
      :excel="excel"
    >
    <template v-slot:actions>
      <v-btn class="mr-1 px-2" depressed :small='$isMobile' color="blue-grey" dark @click="repeatModal = { show: true}">客户查重</v-btn>
    </template>
    <template v-slot:condition>
      <v-col cols="6" class="pr-2 pb-0 pt-c-12 px-0">
        <base-marerial-user-select hide-details='auto' @on-change="loadData" label='负责人' outlined dense v-model="item.params.userIds" mid :menu='$constants.SysMenu.CUSTOMER_M_ID'></base-marerial-user-select>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0">
        <v-select
          :items="[{ text: '2天内', value: 2 },{ text: '3天内', value: 3 },{ text: '7天内', value: 7 }]"
          label="距离退回公海天数"
          v-model="item.params.backPoolDay"
          hide-details='auto'
          outlined dense
          clearable
          clear-icon="mdi-close-circle-outline"
          @change="loadData"
        ></v-select>
      </v-col>
      <v-col cols="6" class="pr-2 pb-0 pt-c-10 px-0">
        <v-select
          :items="[{ text: '有合同', value: 1 }, { text: '无合同', value: 2 }]"
          label="有无合同"
          v-model="item.params.haveContract"
          hide-details='auto'
          outlined dense
          clearable
          clear-icon="mdi-close-circle-outline"
          @change="loadData"
        ></v-select>
      </v-col>
      <v-col cols="6" md='2' class="pr-2 pb-0 pt-c-10 px-0">
        <v-select
          :items="[{ text: '已绑定', value: 1 }, { text: '未绑定', value: 2 }]"
          label="是否绑定微信"
          v-model="item.params.haveBind"
          hide-details='auto'
          outlined dense
          clearable
          clear-icon="mdi-close-circle-outline"
          @change="loadData"
        ></v-select>
      </v-col>
    </template>

    <template v-slot:foot="{ total }">
      <td :colspan="item.headers.length"  :style="$isMobile ? '' : 'border-top: #e4e4e4 1px solid'">
        <div class="my-3 mx-4">
          <span class="size-13 grey--text">客户数</span>&nbsp;<span class="size-15 blue--text font-family-Impact">{{total === null ? 0 : total.allCutsomer}}</span>&nbsp;
          <span class="size-13 grey--text">签单客户</span>&nbsp;<span class="size-15 orange--text font-family-Impact">{{total === null ? 0 : total.haveContract}}</span>&nbsp;
          <br>
          <span class="size-13 grey--text">客户数(本)</span>&nbsp;<span class="size-15 indigo--text font-family-Impact">{{total === null ? 0 : total.selfCutsomer}}</span>&nbsp;
          <span class="size-13 grey--text">签单数(本)</span>&nbsp;<span class="size-15 green--text font-family-Impact">{{total === null ? 0 : total.selfHaveContract}}</span>&nbsp;
          <span class="size-13 grey--text">剩余容量(本)</span>&nbsp;<span class="size-15 pink--text font-family-Impact">{{total === null ? 0 :total.surplus}}</span>&nbsp;
        </div>
      </td>
    </template>

    <template v-slot:expanded-content="{ item }">
      <v-divider></v-divider>
      <detail-view :item='item' show-arrows></detail-view>
    </template>
    </base-material-table-mobile>
    <add-view :item='addModal' @on-load-data='loadData'></add-view>
    <follow-view :item='followModal' @on-load-data='loadData'></follow-view>
    <more-view :item='moreModal' @on-load-data='loadData'></more-view>
    <move-view :item='moveModal' @on-load-data='loadData'></move-view>
    <schedule-view :item='scheduleModal'></schedule-view>
    <card-view :item='cardModal' @on-load-data='loadData'></card-view>
    <code-view :item='codeModal'></code-view>
    <call-view :item='callModal' @on-call-success='callSuccess'></call-view>
    <contacts-view :item='contactsModal' @on-load-data='loadData'></contacts-view>
    <contract-edit :item='contractModal' @on-load-data='loadData'></contract-edit>
    <iaddress-add :item='iAddressModal' @on-load-data='loadData'></iaddress-add>
    <repeat-view :item='repeatModal'></repeat-view>
    <v-dialog v-model="dialog" max-width="320">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="warning">mdi-alert</v-icon>&nbsp;
          系统提示
        </v-card-title>
        <v-card-text>
          <div class="text-h6 pa-2">确定退回公海池吗？</div>
        </v-card-text>
        <v-card-actions class="justify-end p4-1">
          <v-btn text small color="blue" @click="dialog = false">取消</v-btn>
          <v-btn color="primary" :loading="loading" depressed small @click="save">
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { serialNumber } from '@/utils/stringUtil.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { save } from '@/api/customer/index.js'
  import ScheduleView from '@/views/pages/pc/schedule/job/components/CustomAdd.vue'
  import DetailView from './Detail.vue'
  import AddView from './components/Add'
  import FollowView from './components/Follow.vue'
  import MoreView from './components/More.vue'
  import RepeatView from './components/Repeat.vue'
  import MoveView from './components/Move.vue'
  import CardView from './components/Card.vue'
  import CodeView from './components/Code.vue'
  import CallView from './components/Call.vue'
  import ContactsView from './components/Contacts.vue'
  import IaddressAdd from '../iaddress/components/Add.vue'
  import ContractEdit from '../../contract/info/components/Add.vue'

  export default {
    name: 'CustomerIndex',
    components: {
      AddView,
      FollowView,
      ContactsView,
      MoreView,
      ContractEdit,
      IaddressAdd,
      MoveView,
      ScheduleView,
      RepeatView,
      CardView,
      CodeView,
      CallView,
      DetailView
    },
    data() {
      return {
        tab: 0,
        form: {},
        dialog: false,
        loading: false,
        stageItems: [],
        tradeItems: [],
        degreeItems: [],
        callModal: { show: false, data: {} },
        moveModal: { show: false, data: {} },
        addModal: { show: false, data: {} },
        editModal: { show: false, data: {} },
        repeatModal: { show: false, data: {} },
        scheduleModal: { show: false, data: {} },
        cardModal: { show: false, data: {} },
        followModal: { show: false, data: {} },
        moreModal: { show: false, data: {} },
        contactsModal: { show: false, data: {} },
        contractModal: { show: false, data: {} },
        iAddressModal: { show: false, data: {} },
        codeModal: { show: false },
        item: {
          total: true,
          mobile: true,
          path: 'customer/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'add', show: this.$_has('cus-customer-add') },
            { event: 'download', show: this.$_has('cus-customer-down') }
          ],
           sort: {
            orderByField: 'degree_id',
            asc: false
          },
          params: {
            poolStatus: 1,
            backPoolDay: '',
            haveContract: '',
            haveBind: ''
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              mobile: true,
              sortable: false,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => this.$refs.table.showMore(row, idx)
              }
            },
            {
              text: '客户名称',
              align: 'center',
              width: 200,
              divider: true,
              value: 'name',
              sortable: false,
              copy: true,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '客户地址',
              align: 'center',
              width: 200,
              hidden: true,
              value: 'contactsAddress',
              sortable: false,
              search: { type: 'input' }
            },
            {
              text: '是否跟进',
              align: 'center',
              width: 120,
              divider: true,
              value: 'followRecords',
              sortable: false,
              mobile: true,
              chip: {
                color: (val) => (val != null && val.length > 0 ? 'primary' : 'grey'),
                formatter: (val) => (val != null && val.length > 0 ? '有跟进' : '无跟进')
              },
              search: {
                type: 'select',
                secKey: 'haveFollow',
                options: () => [
                  { label: '有跟进', value: 1 },
                  { label: '无跟进', value: 2 }
                ]
              }
            },
            {
              text: '负责人',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'contactsPersonList',
              sortable: false,
              formatter: function(val) {
               let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|"))
              }
            },
            {
              text: '重要程度',
              align: 'center',
              divider: true,
              width: 100,
              value: 'degreeDic.name',
              mobile: true,
              sortable: false
            },
            {
              text: '客户阶段',
              align: 'center',
              divider: true,
              width: 100,
              value: 'stageDic.name',
              sortable: false,
              mobile: true,
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'stageId',
                options: () => this.stageItems
              }
            },
            {
              text: '客户行业',
              align: 'center',
              divider: true,
              width: 210,
              value: 'tradeDic.name',
              copy: true,
              sortable: false,
              mobile: true,
              search: {
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'tradeId',
                options: () => this.tradeItems
              }
            },
            {
              text: '客户来源',
              align: 'center',
              divider: true,
              width: 100,
              value: 'fromDic.name',
              sortable: false
            },
            {
              text: '客户性质',
              align: 'center',
              width: 100,
              divider: true,
              value: 'natureDic.name',
              sortable: false
            },
            {
              text: '客户类型',
              align: 'center',
              divider: true,
              width: 100,
              mobile: true,
              value: 'typeDic.name',
              sortable: false,
            },
            {
              text: '客户等级',
              align: 'center',
              divider: true,
              width: 180,
              value: 'levelDic.name',
              sortable: false
            },
            {
              text: '所属地区',
              align: 'center',
              divider: true,
              width: 180,
              value: 'area',
              mobile: true,
              sortable: false
            },
            {
              text: '创建时间',
              align: 'center',
              width: 120,
              value: 'createTime',
              sortable: false,
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '提醒',
              align: 'center',
              divider: true,
              width: 70,
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-alarm',
                onClick: (row) => this.scheduleModal =
                {
                  show: true,
                  params: {
                    type: 1,
                    data: { name: row.name }
                  }
                },
              }
            },
            {
              text: '绑微信',
              align: 'center',
              divider: true,
              width: 80,
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-qrcode',
                onClick: (row) => this.codeModal = { show: true, data: row },
              }
            },
            {
              text: '呼叫',
              align: 'center',
              divider: true,
              width: 60,
              value: '',
              sortable: false,
              mobile: true,
              icon: {
                value: 'mdi-phone-forward-outline',
                onClick: (row) => this.callModal = { show: true, data: row },
              }
            },
            {
              text: '绑定数量',
              align: 'center',
              divider: true,
              width: 85,
              value: 'wxUserInfoList',
              sortable: false,
              formatter: (val) => val.length
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              sortable: false,
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  // {
                  //   text: '删除',
                  //   color: 'warning',
                  //   icon: 'mdi-delete',
                  //   onClick: (row, btn) => this.$refs.table.doDelete(row, btn),
                  //   disable: () => !this.$_has('cus-customer-delete')
                  // },
                  {
                    text: '编辑',
                    color: 'primary',
                    icon: 'mdi-pencil',
                    onClick: (row) => this.addModal = { show: true, data: row },
                    disable: () => !this.$_has('cus-customer-edit')
                  },
                  {
                    text: '移交',
                    color: 'cyan',
                    icon: 'mdi-link-variant-remove',
                    onClick: (row) => this.moveModal = { show: true, data: row },
                    disable: () => !this.$_has('cus-customer-move')
                  },
                  {
                    text: '跟进',
                    color: 'indigo',
                    icon: 'mdi-format-list-bulleted-square',
                    onClick: (row) => this.followModal = { show: true, customer: row },
                    disable: () => !this.$_has('cus-follow-record-add')
                  },
                  {
                    text: '合同',
                    color: 'blue',
                    icon: 'mdi-file-document-edit',
                    onClick: (row) => this.contractModal = { show: true, customerId: row.id, customerName: row.name },
                    disable: () => !this.$_has('con-contract-info-add')
                  },
                  {
                    text: '联系人',
                    color: 'purple',
                    icon: 'mdi-account-plus',
                    onClick: (row) => this.contactsModal = { show: true, data: row },
                    disable: () => !this.$_has('cus-customer-contacts-person-add')
                  },
                  {
                    text: '发票地址',
                    color: 'brown',
                    icon: 'mdi-map-marker-outline',
                    onClick: (row) => {
                      this.iAddressModal = { show: true, customerId: row.id, customerName: row.name }
                    },
                    disable: () => !this.$_has('cus-customer-invoice-address-add')
                  },
                  {
                    text: '财务+更多',
                    color: 'pink',
                    icon: 'mdi-chart-box-outline',
                    onClick: (row) => this.moreModal = { show: true, data: row },
                    disable: () => false
                  },
                  {
                    text: '退回公海池',
                    color: 'warning',
                    icon: 'mdi-backup-restore',
                    onClick: (row) => {
                      this.dialog = true
                      this.form = row
                      this.form.poolStatus = 2
                    },
                    disable: () => !this.$_has('cus-customer-edit')
                  }
                ]
              }
            }
          ]
        },
        excel: {
          path: 'customer/down',
          filename: `${serialNumber()}_客户信息.xls`,
          fields: {
            客户名称: 'name',
            客户阶段: 'stageDic.name',
            客户行业: 'tradeDic.name',
            客户来源: 'fromDic.name',
            客户性质: 'natureDic.name',
            客户类型: 'typeDic.name',
            客户等级: 'levelDic.name',
            客户地区: 'area',
            客户地址: 'address',
            负责人: {
              field: 'contactsPersonList',
              callback: (value) => {
                let name = ''
                value.forEach(item => {
                  name += item.name
                })
                return name
              }
            },
            创建时间: {
              field: 'createTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            }
          }
        }
      }
    },
    methods: {
      add () {
        this.addModal = { show: true }
      },
      callSuccess (data) {
        this.followModal = { show: true, data: data }
      },
      save () {
        this.loading = true
        save(this.form).then(res => {
          if (res.status === 200) {
            this.dialog = false
            this.loadData()
            this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
          }
          this.loading = false
        })
      },
      loadData () {
        this.$refs.table.loadData()
      },
      async getSelectItems () {
        await getByPids(
            {
            pids: [
              this.$constants.customerStagePid,
              this.$constants.customerTradePid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.customerStagePid === result.id) {
                this_.stageItems = result.data
              } else if (this_.$constants.customerTradePid === result.id) {
                this_.tradeItems = result.data
              }
            })
          }
        })
      }
    },
    created() {
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
